import React from 'react';

import WidgetInput from './WidgetInput';

import PropsHidden from './interfaces/PropsHiddenInterface';

export default class WidgetHidden extends WidgetInput<PropsHidden> {
    constructor(props: PropsHidden) {
        super(props);
        this.props.handleChange(this.props.name, this.props.value || '');
    }

    render() {
        return React.createElement('input', {
            name: this.props.name,
            onChange: this.onChange,
            type: this.props.type,
            required: this.props.required,
            value: this.props.value || '',
        });
    }
}
